module.exports = __webpack_public_path__ + "img/Atelier_3.8f16cf9f.jpg";